import { render } from "./ProductDetail.vue?vue&type=template&id=312d8ac0&scoped=true"
import script from "./ProductDetail.vue?vue&type=script&lang=ts"
export * from "./ProductDetail.vue?vue&type=script&lang=ts"

import "./ProductDetail.vue?vue&type=style&index=0&id=312d8ac0&lang=css"
import "./ProductDetail.vue?vue&type=style&index=1&id=312d8ac0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-312d8ac0"

export default script